import { getIn } from 'seamless-immutable';
import { useBuyTogether } from './buy-together';
import { existOffer } from '../helpers/buy-together';

export const useProduct = (publication = []) => {
  const product = getIn(publication, ['products'], []).slice(0, 2);
  const { data } = useBuyTogether(product[0]?.id, product[1]?.id);

  const firstProduct = existOffer(data?.firstProduct);
  const secondProduct = existOffer(data?.secondProduct);

  if (!(firstProduct && secondProduct)) {
    return [];
  }

  return [data.firstProduct, data.secondProduct];
};
